import React, { createContext, useContext, useEffect, useState } from 'react'
import { ordersApi } from '../restaurant.api'

const OrdersContext = createContext({
  loading: true,
  orders: [],
  search: '',
  setSearch: () => {},
  statusFilter: '',
  setStatusFilter: () => {},
  refresh: () => {},
})

export const useOrders = () => useContext(OrdersContext)

export const ORDER_STATUSES = [
  'Pending',
  'Confirmed',
  'Preparing',
  'Out For Delivery',
  'Delivered',
  'Cancelled',
]

export const OrdersProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState([])
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')

  const load = async () => {
    setLoading(true)
    const { response } = await ordersApi.list({ limit: 1000 })
    if (response) setOrders(response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filtered = orders.filter((order) => {
    if (statusFilter && order.status !== statusFilter) return false
    if (!search) return true
    const q = search.toLowerCase()
    return (
      (order.orderNumber || '').toLowerCase().includes(q) ||
      (order.customerInfo?.name || '').toLowerCase().includes(q) ||
      (order.customerInfo?.phone || '').toLowerCase().includes(q)
    )
  })

  return (
    <OrdersContext.Provider
      value={{
        loading,
        orders: filtered,
        allOrders: orders,
        search,
        setSearch,
        statusFilter,
        setStatusFilter,
        refresh: load,
      }}
    >
      {children}
    </OrdersContext.Provider>
  )
}
